import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["isActive"];
// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/icon-navigation-template-activatable/src/index.tsx
import React from 'react';
import baseIcon, { navigationActivatableDefaultStyleSheetGetter, defaultNavigationIconGroupProps, defaultNavigationIconShapeSize } from '@bubble-ui/temp-icon-base';
import useDeprecationWarning from '@bubble-ui/hook-use-deprecation-warning';
var NavigationIconShoppingPath = 'M15,2.99999995 C17.6887547,2.99999995 19.8818181,5.12230667 19.9953805,7.78311035 L20,7.99999995 L19.9991368,9.99999995 L23.8759686,9.99999998 L25.68711,23.6399564 C25.82851,24.5120776 25.5646303,25.4010898 24.9703173,26.054834 C24.3760044,26.7085782 23.5160895,27.0557402 22.7,27 L22.7,27 L7.3655216,26.9978512 C6.48391047,27.0557402 5.62399557,26.7085782 5.02968265,26.054834 C4.43536973,25.4010898 4.17148995,24.5120776 4.30870455,23.6683436 L4.30870455,23.6683436 L6.12403144,9.99999998 L9.99913679,9.99999995 L9.99999998,7.99999995 C9.99999998,5.23857621 12.2385762,2.99999995 15,2.99999995 Z M22.123,12 L7.87599997,12 L6.28710991,23.9600436 C6.24949611,24.1920364 6.30428952,24.4278806 6.43686244,24.6182951 L6.43686244,24.6182951 L6.5095628,24.7094884 C6.69400474,24.9123745 6.96087488,25.0201144 7.29999997,25 L7.29999997,25 L22.8821474,25.0022413 C23.1136915,24.9873898 23.3323441,24.8833908 23.4904372,24.7094884 C23.6748791,24.5066022 23.7567729,24.2307019 23.7087046,23.9316565 L23.7087046,23.9316565 L22.123,12 Z M18,14 L18,16 L12,16 L12,14 L18,14 Z M15,4.99999995 C13.4023191,4.99999995 12.0963391,6.24891993 12.0050927,7.82372718 L12,7.99999995 L11.9991368,9.99999995 L17.9991368,9.99999995 L18,7.99999995 C18,6.34314572 16.6568543,4.99999995 15,4.99999995 Z';
var NavigationIconShoppingActivePath = 'M15,3 C17.6887547,3 19.8818181,5.12230671 19.9953805,7.78311038 L20,8 L19.9991368,9.999 L23.8759685,10 L25.6871099,23.6399564 C25.82851,24.5120776 25.5646302,25.4010897 24.9703173,26.0548339 C24.3760044,26.7085781 23.5160895,27.0557401 22.7,27 L22.7,27 L7.36552163,26.9978511 C6.4839105,27.0557401 5.6239956,26.7085781 5.02968269,26.0548339 C4.43536978,25.4010897 4.17149,24.5120776 4.30870459,23.6683436 L4.30870459,23.6683436 L6.12403147,10 L9.99913683,9.999 L10,8 C10,5.23857625 12.2385763,3 15,3 Z M18,14 L12,14 L12,16 L18,16 L18,14 Z M15,5 C13.4023191,5 12.0963391,6.24891996 12.0050927,7.82372721 L12,8 L11.9991368,9.999 L17.9991368,9.999 L18,8 C18,6.34314575 16.6568542,5 15,5 Z';
var NavigationIcon = baseIcon('NavigationIconShopping', {
  getPath: _ref => {
    var {
      isActive
    } = _ref;
    return isActive ? NavigationIconShoppingActivePath : NavigationIconShoppingPath;
  },
  styleSheetPropsGetter: (_ref2, designVersion) => {
    var {
      isActive,
      color,
      colorToken,
      colorTokenArgs
    } = _ref2;
    return {
      isActive,
      color,
      designVersion,
      colorToken,
      colorTokenArgs
    };
  },
  defaultStyleSheetGetter: navigationActivatableDefaultStyleSheetGetter,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  restOfPropsSanitizer: _ref3 => {
    var {
        isActive
      } = _ref3,
      restOfProps = _objectWithoutProperties(_ref3, _excluded);
    return restOfProps;
  },
  groupProps: defaultNavigationIconGroupProps,
  shapeSize: defaultNavigationIconShapeSize
});
var NavigationIconShopping = props => {
  useDeprecationWarning({
    componentName: 'NavigationIconShopping',
    removalDate: 'v6.0.0'
  });
  return /*#__PURE__*/React.createElement(NavigationIcon, props);
};
NavigationIconShopping.displayName = 'NavigationIconShopping';
export default NavigationIconShopping;
//# sourceMappingURL=index.js.map